import Vue from 'vue';
import { EventBus } from '@/services/Event.js';

export default {
    name: 'userSubscribeNews',
    data() {
        return {
            isProcessing: true,
            isSubscribed: false,
            email: null,
            name: null,
            id: null
        }
    },
    methods: {
        isValidEmailAddress(emailAddress) {
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return regex.test(emailAddress);
        },
        getData(user) {
            var self = this;
            if (user.userId) {
                if (user.email) {
                    if (self.id != user.userId) {
                        self.name = user.fullName;
                        self.email = user.email;
                        self.id = user.userId;
                    }
                }
                else if (user.details) {
                    if (self.id != user.userId) {
                        self.name = user.details.fullName;
                        self.email = user.details.email;
                        self.id = user.userId;
                    }
                }

                if (!self.isSubscribed) {
                    self.isProcessing = false;
                }
            }
        },
        saveData() {
            var self = this;
            self.isProcessing = false;
            if (!self.isValidEmailAddress(self.email)) {
                self.$notify({ message: "Email is invalid!", type: 'danger' });
                return;
            }

            Vue.http.get('https://triathlonireland.us8.list-manage.com/subscribe/post-json?' +
            '?u=' + '420f5df4821ad501e9255096d' + '&id=' + '079be44f95' +
            '&EMAIL=' + self.email + '&MMERGE3=' + self.name)
            .then((response) =>
            {
                self.$notify({ message: "You are subscribed!", type: 'success' });
                self.isSubscribed = true;
                self.isProcessing = false;

            }, (response) =>
            {
                self.$notify({ message: "Something went wrong. Newsletter server doesn't reponded. Please try again later.", type: 'danger' });
            });
        },

    },
    mounted() {
        var self = this;
        EventBus.$off("user-update-subscribe-news");
        EventBus.$on("user-update-subscribe-news", (user) => { self.getData(user); });
    }
}



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/subscribe-news/subscribe-news.js